module.exports = __webpack_public_path__ + "static/media/diamondsColored.568701dc.svg";